export default "__VITE_PUBLIC_ASSET__e335a4e1__"